export const messages = {
    en: {
        message: {
            buttons: {
                contact: "Contact us",
                read_more: "Read more about it",
                open_account : "Open your account",
                city: {
                    brussels: "Contact the Brussels team",
                    paris: "Contact the Paris team",
                    london: "Contact the London team",
                }
            },
            navigation: {
                home: "Home",
                story: "Our Values & Story",
                areas: "Areas of operations",
                governance: "Governance",
                relations: "Investor's relations",
                sao: "Online Term Deposits",

                individual: "Individual banking",
                corporate: "Corporate banking",
                financial: "Financial institutions",
                management_solutions: "Wealth management",

                contact: "Contact",
                privacy: "Privacy Statement",
                cookie: "Cookie Policy",
                complaint: "Raise a complaint",
                legal_doc: "Legal documentation",

                career : "Careers",
                job : "Job opening",

                soon: "coming soon",
            },
            header: {
                nav_title1: "About us",
                nav_title2: "Our services",
                nav_title3: "Contact",
            },
            footer: {
                nav_title1: "DISCOVER BBE",
                nav_title2: "RESOURCES",
                disclaimer: "Byblos Bank Europe S.A. is authorised and regulated by the National Bank of Belgium and the Financial Services and Markets Authority.  Byblos Bank Europe S.A. London Branch is deemed authorised by the Prudential Regulation Authority. Subject to regulation by the Financial Conduct Authority and limited regulation by the Prudential Regulation Authority. Details of the Temporary Permissions Regime, which allows EEA-based firms to operate in the UK for a limited period while seeking full authorisation, are available on the Financial Conduct Authority’s website."
            },

            home_page: {
                h2: "better banking experience",
                soon: "coming soon",
                individual_solutions: "Individual Solutions",
                business_solutions: "Business Solutions",
                areas: "Our areas of operations",
                left_column: {
                    section_name: "FAQ",
                    title: `Questions? <br class="hide-small">Ask away.`,
                    description: "Any questions about BBE, our services or anything else? Check out our FAQ.",
                },
            },
            story_page: {
                quote_title: "Our mission",
                history_title: "Our history",
            },
            banking_page: {
                soon: "coming soon"
            },
            cookie: {
                header_p: `By accessing our websites using any device, you agree that this Cookie Policy applies to that use in addition to any other terms and conditions which may apply. <br>
                            This Cookie Policy may be updated periodically. In that case, we will inform you of any significant changes by posting a prominent notice on the website.`,
                section_name: "Lastly updated on 02/12/2022",
                title: "Cookie Policy",
                accordion: {
                    accordion_tab1: {
                        title:"What are cookies?",
                        p1: "Cookies are small pieces of information, normally consisting of just letters and numbers, which online services provide when users visit them.",
                        p2: "Software on the user's device (for example, a web browser) can store cookies and send them back to the website next time they visit to recognise you.",
                        p3: "Cookies are not dangerous. They are not computer programs, and they cannot be executed as a code. All modern versions of popular web browsers allow users to set their own limitations to the number of cookies saved on their devices.",
                        p4: "Cookies are stored on the user’s device. They cannot access the hard drive, so they cannot read other information saved on the hard drive or obtain user's e-mail address etc. They only contain and transfer to the server as much information as the users themselves have disclosed to the website.",
                    },
                    accordion_tab2: {
                        title:"How are cookies used?",
                        p1: "Cookies are a specific technology that store information between website visits. They are used in numerous ways, such as: ",
                        li1: "remembering what’s in a shopping basket when shopping for goods online; ",
                        li2: "supporting users to log in to a website; ",
                        li3: "analysing traffic to a website; or ",
                        li4: "tracking users' browsing behaviour. ",
                        p2: "Cookies can be useful because they allow a website to recognise a user’s device. They are widely used in order to make websites work, or work more efficiently, as well as to provide information to the owners of the site. Without cookies, or some other similar method, websites would have no way to ‘remember’ anything about visitors, such as how many items are in a shopping basket or whether they are logged in."
                    },
                    accordion_tab3: {
                        title:"Your rights as a visitor of our website",
                        p1: "You can control how cookies are placed on your device from within your web browser. Thus, you can accept or refuse cookies via a pop-up window when you first visit our website.",
                        p2: "You may change your choice of preferred cookies or completely withdraw given consent by clicking the “Privacy settings” link at the top of the window. ",
                        p3: "You set your browser to let you know each time that a website tries to set a cookie. You can restrict or block cookies using your browser settings or allow cookies from specific websites by making them “trusted websites” in your Internet browser.",
                        p4: "If you have disabled one or more cookie categories, we may still use information collected from existing cookies, but we will stop using the disabled cookies to gather any further information. You can delete existing cookies from your browser.",
                        p5: "Please be aware that some of our services will not function if your browser or device does not accept our cookies.",
                    },
                    accordion_tab4: {
                        title:"What cookies do we use?",
                        p1: "We use various cookies for the following purposes:",
                        li1: "Information security and enhancing performance;",
                        li2: "Administering our website and enhancing the user experience;",
                        li3: "Obtain a better understanding of customer needs for the continuous improvement of our website and applications;",
                        li4: "Analysing how our website and applications are used and making statistics;",
                        li5: "Show more relevant information and advertising on our websites and application.",
                        p2: `<strong>Essential and non-essential cookies</strong>`,
                        p3: "Cookies can be classified as either ‘essential’ or ‘non-essential’.",
                        p4: `<strong>Essential cookies.</strong> These are cookies that are:`,
                        li6: "used solely to carry out or facilitate the transmission of communications over a network;",
                        li7: "strictly necessary to provide an online service (e.g. our website or a service on our website) which you have requested;",
                        li8: "comply with legal obligations e.g. under data protection laws.",
                        p5: `<strong>Non-essential cookies.</strong> These are any cookies that do not fall within the definition of essential cookies, for instance, cookies used to analyse your behaviour on a website (‘analytical’ cookies) or cookies used to display advertisements to you (‘advertising’ cookies).`,
                        p6: "We use cookies that fall under one of the following categories:",
                        th1: "Category of cookies",
                        th2: "Purpose",
                        td1: `<p><strong>Essential (Strictly Necessary)</strong></p>`,
                        td2: `<p>These cookies are necessary for the website to function and cannot be switched off in our systems. They allow to carry out or facilitate the transmission of
                                    communications over a network, or to provide an online service (e.g. our website or a service on our website) which you have requested.</p>`,
                        td3: `<p><strong>Preference and Functionality</strong></p>`,
                        td4: `<p>These cookies collect information about your choices and preferences and make using the website more practical, like remembering your preferred language or the region that you are in. They are non-essential to use, however, without these cookies certain functionality may become unavailable.</p>`,
                        td5: `<p><strong>Analytical</strong></p>`,
                        td6: `<p>These cookies collect information that is used to help us understand how our websites are being used. We do so to improve our websites and application for you in order to enhance your experience, using a service provided by Google Analytics. </p>`,
                        td7: `<p><strong>Advertisement (targeting)</strong></p>`,
                        td8: `<p>These cookies are used to make advertising messages more relevant to you and your interests. They also perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed, and in some cases selecting advertisements that are based on your interests.</p>`,


                    },
                    accordion_tab5:{
                        title:"List of cookies we use",
                        th1 : "Category of cookies",
                        th2 : "Visitor Actions",
                        th3 : "Cookie",
                        th4 : "Domain",
                        th5 : "Purpose",
                        th6 : "Lifespan",

                        td1 : `<p><strong>Essential (Strictly Necessary)</strong></p>`,
                        td2 : `<p>For this type of cookies, your consent is not required.</p>`,
                        td3 : `<p>SEARCH_SAMESITE</p>`,
                        td4 : `<p>google.com</p>`,
                        td5 : `<p>Allows servers to mitigate the risk of CSRF and information leakage attacks by asserting that a particular cookie should only be sent with requests initiated from the same registrable domain.</p>`,
                        td6 : `<p>6 months</p>`,

                        td7: `<p>gdprPlugin</p>`,
                        td8: `<p>byblosbankeur.com</p>`,
                        td9: `<p>Refers to the privacy settings selected by the user.</p>`,
                        td10: `<p>1 month</p>`,

                        td11: `<p>gdprPluginGroup</p>`,
                        td12: `<p>byblosbankeur.com</p>`,
                        td13: `<p>Gets the user consent to store cookies on their device.</p>`,
                        td14: `<p>1 month</p>`,

                        td15 : `<p>group_1, group_2, group_3, group_4</p>`,
                        td16 : `<p>byblosbankeur.com</p>`,
                        td17 : `<p>Accepts cookies group.</p>`,
                        td18 : `<p>1 month</p>`,


                    },
                    accordion_tab6 : {
                        title:"Changing Browser Settings",
                        p1: "Browser settings can be changed so that they do not accept or store cookies at any time.",
                        p2: "You can also choose to receive a message each time before accepting cookies or to only accept cookies from certain websites. More information can be found on following websites:",
                        li1: `<a href="https://support.google.com/chrome/answer/95647?hl=en">Google Chrome browser</a>`,
                        li2: `<a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">Microsoft Internet Explorer browser</a>`,
                        li3: `<a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">Mozilla Firefox browser</a>`,
                        li4: `<a href="https://support.apple.com/en-ie/guide/safari/manage-cookies-and-website-data-sfri11471/mac">Apple Safari browser</a>`,
                        li5: `<a href="https://www.opera.com/help/tutorials/security/privacy/">Opera web browser</a>`,
                    },
                    accordion_tab7 : {
                        title:"More information about cookies",
                        p1 : `For more information about cookies and to learn how to manage them or turn them off, please visit:`,
                        p2 : `<a href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a>`,
                        p3 : `<a href="https://www.youronlinechoices.eu/">https://www.youronlinechoices.eu/</a>`,
                        p4 : `These are external public links not related to Byblos Bank Europe S.A.`,
                    },
                    accordion_tab8 : {
                        title:"Ask more about cookies?",
                        p1 : 'For more information about cookies, please contact the group Data Protection Officer at',

                    },
                },
                content_card :{
                    p1 : 'For the whole group of the BBE European entities, there is one Data Protection Officer who you can contact also as a customer of BBE Paris and BBE London. You can contact them with any data protection related question or share your comment at',
                        p2:'Every request to exercise your rights or complaint that you submit to BBE will be handled and answered within the shortest possible time frame. We have an obligation to assist you in exercising your rights or explain why it might not be possible within 1 month from receiving your request. In case of a complex request, this period can extend to 2 months.'
                }

            },
            sao : {
                benefits : {
                    li1 : `<strong>Easy account opening with ItsMe</strong><br><span>or via your eID card</span>`,
                    li2 : `<strong>Convenient periods for you</strong><br><span>6 months, 9 months, or 1 year</span>`,
                    li3 : `<strong>Roll over or enjoy the return</strong><br><span>Continue or stop the term at maturity</span>`,
                    li4 : `<strong>Currency of choice</strong><br><span>EUR-USD-GBP</span>`,
                    table1 : "Period",
                    table2 : "Gross",
                    table3 : "Net",
                },
                explain : {
                    h2 : "The ABC of the BBE Online Term Deposits Account",
                },
                opening : {
                    p1 : "Read the information to the bottom of the page first.",
                }
            },
            contact:{
                title:"BBE <br> is here to help you",
                text:"Do you have a question about our banking solutions? Would you like to know more about our product range? Contact us today.",
                firstname:"First name",
                lastname:"Last name",
                phone:"Phone number",
                phone_placeholder:"Mobile or fixed line",
                email:"Email",
                subject:"Subject",
                subject_account:"Account Opening",
                subject_product:"Question about a product",
                subject_info:"General info",
                subject_other:"Other",
                message:"Your message",
                send:"Send",
                thanks_title:"Thank you for contacting BBE !",
                thanks_text:"Your message was well received. <br>You will receive a confirmation email shortly.",
                thanks_button:"Back to home page",
                map_brussels:"Brussels-headquarters",
                map_london:"London-office",
                map_paris:"Paris-office",
            },
            career:{
                job_info:'More Info',
                apply: 'Apply',
                apply_job: 'Apply for this position',
                download: 'Download the document',
                city:{
                    label:'City',
                    brussels:'Brussels',
                    paris:'Paris',
                    london:'London',
                },
                employment:{
                    label: 'Employment type',
                    full_time:'Full-time',
                    part_time:'Part-time',
                    internship:'Internship',
                    traineeship:'Traineeship',
                    student_job:'Student job',
                },
                form:{
                    firstname:"First name",
                    lastname:"Last name",
                    email:"Email",
                    ex_email:"ex. John{'@'}email.com",
                    phone:"Phone number",
                    cv:"CV",
                    motivation:"Cover letter (optional)",
                    upload_button:'Upload',
                    remove_button:'remove',
                    message:"Comments (optional)",
                    max_char:"500 characters max.",
                    optin_privacy:'I have read and agreed with the <a href="/privacy" target="_blank">Privacy Statement</a> of BBE.',
                    optin_recontact:'I give my consent to be contacted by the HR department via emails for future job openings and relevant opportunities within BBE. I can withdraw this consent any time by answering these emails received from the HR department or by contacting the Data Protection Officer as explained in the <a href="/privacy" target="_blank">Privacy Statement</a> of BBE (optional).',
                    button:'Submit application',
                    thanks:'Your application was successfully submitted! You will shortly receive a confirmation email to verify this. Thank you for your interest in BBE, and we look forward to reviewing your application.'
                }
            }
        }
    },
    fr: {
        message: {
            buttons: {
                contact: "Contactez nous",
                read_more: "Read more about it",
                open_account : "Ouvrir un compte",
                city: {
                    brussels: "Contactez l'équipe de Bruxelles",
                    paris: "Contactez l'équipe de Paris",
                    london: "Contactez l'équipe de Londres",
                }
            },
            navigation: {
                home: "Accueil",
                story: "Nos valeurs et notre Histoire",
                areas: "Zones d’activité",
                governance: "Gouvernance",
                relations: "Relations avec les investisseurs",
                sao: "Compte d’épargne en ligne",

                individual: "BBE pour les particuliers",
                corporate: "BBE pour les entreprises",
                financial: "Institutions financières",
                management_solutions: "Gestion de patrimoine",

                contact: "Contact",
                privacy: "Déclaration de confidentialité",
                cookie: "Politique en matière de cookies",
                complaint: "Déposer une plainte",
                legal_doc: "Documentation juridique",

                career:"Carrières",
                job:"Postes Vacants",

                soon: "Prochainement",
            },
            header: {
                nav_title1: "À propos",
                nav_title2: "Nos services",
                nav_title3: "Contact",
            },
            footer: {
                nav_title1: "DÉCOUVREZ BBE",
                nav_title2: "RESSOURCES",
                disclaimer: "Byblos Bank Europe S.A. est autorisée et réglementée par la Banque nationale de Belgique et l'Autorité des services et marchés financiers. La succursale londonienne de Byblos Bank Europe S.A. est réputée autorisée par la Prudential Regulation Authority. Soumise à la réglementation de la Financial Conduct Authority et à la réglementation limitée de la Prudential Regulation Authority. Les détails du régime des autorisations temporaires, qui permet aux entreprises basées dans l'EEE d'opérer au Royaume-Uni pendant une période limitée tout en cherchant à obtenir une autorisation complète, sont disponibles sur le site Internet de la Financial Conduct Authority."
            },

            home_page: {
                h2: "better banking experience",
                soon: "PROCHAINEMENT",
                individual_solutions: "Solutions pour particuliers ",
                business_solutions: "Solutions pour entreprises",
                areas: "Nos zones d’activités",
                left_column: {
                    section_name: "FAQ",
                    title: `Questions? <br class="hide-small">Ask away.`,
                    description: "Any questions about BBE, our services or anything else? Check out our FAQ.",
                },
            },
            story_page: {
                quote_title: "Notre mission",
                history_title: "Notre histoire",
            },
            banking_page: {
                soon: "prochainement"
            },
            cookie: {
                header_p: `En accédant à nos sites web à l'aide de n'importe quel appareil, vous acceptez que la présente politique en matière de cookies s'applique à cette utilisation, en plus de toutes les autres conditions générales qui peuvent s'appliquer.<br>
                 La présente politique en matière de cookies peut être mise à jour périodiquement. Dans ce cas, nous vous informerons de toute modification importante en publiant un avis bien visible sur le site web.`,
                section_name: "Dernière mise à jour le 02/12/2022",
                title: "Politique en matière de cookies",
                accordion: {
                    accordion_tab1: {
                        title:"Que sont les cookies ?",
                        p1: "Les cookies sont de petits éléments d'information, normalement constitués de lettres et de chiffres, que les services en ligne fournissent lorsque les utilisateurs les visitent.",
                        p2: "Un logiciel sur l'appareil de l'utilisateur (par exemple, un navigateur web) peut stocker des cookies et les renvoyer au site web lors de la prochaine visite pour vous reconnaître.",
                        p3: "Les cookies ne sont pas dangereux. Ce ne sont pas des programmes informatiques, et ils ne peuvent pas être exécutés comme un code. Toutes les versions modernes des navigateurs web populaires permettent aux utilisateurs de fixer leurs propres limites quant au nombre de cookies enregistrés sur leurs appareils.",
                        p4: "Les cookies sont stockés sur l'appareil de l'utilisateur. Ils ne peuvent pas accéder au disque dur et ne peuvent donc pas lire d'autres informations enregistrées sur le disque dur ou obtenir l'adresse électronique de l'utilisateur, etc. Ils contiennent et transfèrent au serveur uniquement les informations que les utilisateurs ont eux-mêmes divulguées au site web.",
                    },
                    accordion_tab2: {
                        title:"Comment les cookies sont-ils utilisés ?",
                        p1: "Les cookies sont une technologie spécifique qui stocke des informations entre les visites de sites web. Ils sont utilisés de nombreuses manières, telles que :",
                        li1: "se souvenir du contenu d'un panier lors d'achats en ligne ;",
                        li2: "aider les utilisateurs à se connecter à un site web ; ",
                        li3: "l'analyse du trafic sur un site web ; ou",
                        li4: "le suivi du comportement de navigation des utilisateurs.",
                        p2: "Les cookies peuvent être utiles car ils permettent à un site web de reconnaître l'appareil d'un utilisateur. Ils sont largement utilisés pour faire fonctionner les sites web, ou les faire fonctionner plus efficacement, ainsi que pour fournir des informations aux propriétaires du site. Sans les cookies, ou toute autre méthode similaire, les sites web n'auraient aucun moyen de \"se souvenir\" des visiteurs, comme le nombre d'articles dans un panier ou le fait qu'ils soient connectés."
                    },
                    accordion_tab3: {
                        title:"Vos droits en tant que visiteur de notre site web",
                        p1: "Vous pouvez contrôler la manière dont les cookies sont placés sur votre appareil depuis votre navigateur web. Ainsi, vous pouvez accepter ou refuser les cookies via une fenêtre pop-up lors de votre première visite sur notre site web.",
                        p2: "Vous pouvez modifier votre choix de cookies préférés ou retirer complètement le consentement donné en cliquant sur le lien \"Paramètres de confidentialité\" en haut de la fenêtre.",
                        p3: "Vous paramétrez votre navigateur pour qu'il vous prévienne chaque fois qu'un site web tente d'installer un cookie. Vous pouvez limiter ou bloquer les cookies à l'aide des paramètres de votre navigateur ou autoriser les cookies provenant de sites web spécifiques en les désignant comme \"sites web de confiance\" dans votre navigateur Internet.",
                        p4: "Si vous avez désactivé une ou plusieurs catégories de cookies, nous pouvons toujours utiliser les informations recueillies à partir des cookies existants, mais nous cesserons d'utiliser les cookies désactivés pour recueillir d'autres informations. Vous pouvez supprimer les cookies existants de votre navigateur.",
                        p5: "Sachez que certains de nos services ne fonctionneront pas si votre navigateur ou votre appareil n'accepte pas nos cookies.",
                    },
                    accordion_tab4: {
                        title:"Quels sont les cookies que nous utilisons ?",
                        p1: "Nous utilisons différents cookies aux fins suivantes :",
                        li1: "Sécurité de l'information et amélioration des performances ;",
                        li2: "administrer notre site web et améliorer l'expérience des utilisateurs ;",
                        li3: "Obtenir une meilleure compréhension des besoins des clients pour l'amélioration continue de notre site web et de nos applications ;",
                        li4: "Analysing how our website and applications are used and making statistics;Analyser la manière dont notre site web et nos applications sont utilisés et établir des statistiques ;",
                        li5: "Afficher des informations et des publicités plus pertinentes sur nos sites web et notre application.",
                        p2: `<strong>Cookies essentiels et non essentiels</strong>`,
                        p3: "Les cookies peuvent être classés comme \"essentiels\" ou \"non essentiels\".",
                        p4: `<strong>Cookies essentiels.</strong> Il s'agit de cookies qui sont :`,
                        li6: "utilisé uniquement pour effectuer ou faciliter la transmission de communications sur un réseau ;",
                        li7: "strictement nécessaire pour fournir un service en ligne (par exemple, notre site web ou un service sur notre site web) que vous avez demandé ;",
                        li8: "se conformer aux obligations légales, par exemple en vertu des lois sur la protection des données.",
                        p5: `<strong>Cookies non essentiels . </strong> Il s'agit de tous les cookies qui ne répondent pas à la définition des cookies essentiels, par exemple, les cookies utilisés pour analyser votre comportement sur un site web (cookies " analytiques ") ou les cookies utilisés pour vous afficher des publicités (cookies " publicitaires ").`,
                        p6: "Nous utilisons des cookies qui relèvent de l'une des catégories suivantes :",
                        th1: "Catégorie de cookies",
                        th2: "Objectif",
                        td1: `<p><strong>Essentiel (Strictement nécessaire)</strong></p>`,
                        td2: `<p>Ces cookies sont nécessaires au fonctionnement du site web et ne peuvent pas être désactivés dans nos systèmes. Ils permettent d'effectuer ou de faciliter la transmission de communications sur un réseau, ou de fournir un service en ligne (par exemple, notre site web ou un service sur notre site web) que vous avez demandé.</p>`,
                        td3: `<p><strong>Préférence et fonctionnalité</strong></p>`,
                        td4: `<p>Ces cookies collectent des informations sur vos choix et préférences et rendent l'utilisation du site web plus pratique, comme la mémorisation de votre langue préférée ou de la région dans laquelle vous vous trouvez. Ils ne sont pas indispensables à l'utilisation, cependant, sans ces cookies, certaines fonctionnalités peuvent devenir indisponibles.</p>`,
                        td5: `<p><strong>Analytique</strong></p>`,
                        td6: `<p>Ces cookies collectent des informations qui sont utilisées pour nous aider à comprendre comment nos sites web sont utilisés. Nous le faisons afin d'améliorer nos sites web et notre application pour vous afin d'améliorer votre expérience, en utilisant un service fourni par Google Analytics.</p>`,
                        td7: `<p><strong>Publicité (ciblage)</strong></p>`,
                        td8: `<p>Ces cookies sont utilisés pour rendre les messages publicitaires plus pertinents pour vous et vos intérêts. Ils remplissent également des fonctions telles que la prévention de la réapparition continue de la même publicité, la garantie d'un affichage correct des publicités et, dans certains cas, la sélection de publicités basées sur vos intérêts.</p>`,
                    },
                    accordion_tab5:{
                        title:"Liste des cookies que nous utilisons",
                        th1 : "Category of cookies",
                        th2 : "Visitor Actions",
                        th3 : "Cookie",
                        th4 : "Domain",
                        th5 : "Purpose",
                        th6 : "Lifespan",

                        td1 : `<p><strong>Essential (Strictly Necessary)</strong></p>`,
                        td2 : `<p>For this type of cookies, your consent is not required.</p>`,
                        td3 : `<p>SEARCH_SAMESITE</p>`,
                        td4 : `<p>google.com</p>`,
                        td5 : `<p>Allows servers to mitigate the risk of CSRF and information leakage attacks by asserting that a particular cookie should only be sent with requests initiated from the same registrable domain.</p>`,
                        td6 : `<p>6 months</p>`,

                        td7: `<p>gdprPlugin</p>`,
                        td8: `<p>byblosbankeur.com</p>`,
                        td9: `<p>Refers to the privacy settings selected by the user.</p>`,
                        td10: `<p>1 month</p>`,

                        td11: `<p>gdprPluginGroup</p>`,
                        td12: `<p>byblosbankeur.com</p>`,
                        td13: `<p>Gets the user consent to store cookies on their device.</p>`,
                        td14: `<p>1 month</p>`,

                        td15 : `<p>group_1, group_2, group_3, group_4</p>`,
                        td16 : `<p>byblosbankeur.com</p>`,
                        td17 : `<p>Accepts cookies group.</p>`,
                        td18 : `<p>1 month</p>`,


                    },
                    accordion_tab6 : {
                        title:"Modification des paramètres du navigateur",
                        p1: "Les paramètres des navigateurs peuvent être modifiés de manière à ce qu'ils n'acceptent ni ne stockent de cookies à tout moment.",
                        p2: "Vous pouvez également choisir de recevoir un message à chaque fois avant d'accepter les cookies ou d'accepter uniquement les cookies de certains sites web. Vous trouverez de plus amples informations sur les sites web suivants :",
                        li1: `<a href="https://support.google.com/chrome/answer/95647?hl=en">Navigateur Google Chrome</a>`,
                        li2: `<a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">Navigateur Microsoft Internet Explorer</a>`,
                        li3: `<a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">Navigateur Mozilla Firefox</a>`,
                        li4: `<a href="https://support.apple.com/en-ie/guide/safari/manage-cookies-and-website-data-sfri11471/mac">Navigateur Apple Safari </a>`,
                        li5: `<a href="https://www.opera.com/help/tutorials/security/privacy/">Navigateur Opera web </a>`,
                    },
                    accordion_tab7 : {
                        title:"Plus d'informations sur les cookies",
                        p1 : `Pour de plus amples informations sur les cookies et pour savoir comment les gérer ou les désactiver, veuillez consulter le site suivant`,
                        p2 : `<a href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a>`,
                        p3 : `<a href="https://www.youronlinechoices.eu/">https://www.youronlinechoices.eu/</a>`,
                        p4 : `Il s'agit de liens publics externes qui ne sont pas liés à Byblos Bank Europe S.A.`,
                    },
                    accordion_tab8 : {
                        title:"Vous voulez en savoir plus sur les cookies ?",
                        p1 : `Pour plus d'informations sur les cookies, veuillez contacter le délégué à la protection des données du groupe à l'adresse `,
                    },
                },
                content_card :{
                    p1 : `Pour l'ensemble du groupe des entités européennes de BBE, il existe un délégué à la protection des données que vous pouvez également contacter en tant que client de BBE Paris et BBE Londres. Vous pouvez le contacter pour toute question relative à la protection des données ou lui faire part de vos commentaires à l'adresse `,
                    p2:` Toute demande d'exercice de vos droits ou toute plainte que vous adressez à BBE sera traitée et fera l'objet d'une réponse dans les plus brefs délais. Nous avons l'obligation de vous aider à exercer vos droits ou de vous expliquer pourquoi cela pourrait ne pas être possible dans un délai d'un mois à compter de la réception de votre demande. En cas de demande complexe, ce délai peut s'étendre à 2 mois.`
                }

            },
            sao : {
                benefits : {
                    li1 : `<strong>Easy account opening with ItsMe</strong><br><span>or via your eID card</span>`,
                    li2 : `<strong>Convenient periods for you</strong><br><span>6 months, 9 months, or 1 year</span>`,
                    li3 : `<strong>Roll over or enjoy the return</strong><br><span>Continue or stop the term at maturity</span>`,
                    li4 : `<strong>Currency of choice</strong><br><span>EUR-USD-GBP</span>`,
                    table1 : "Période",
                    table2 : "Brut",
                    table3 : "Net",
                },
                explain : {
                    h2 : "L'ABC du compte à terme BBE Online\n",
                },
                opening : {
                    p1 : "Read the information to the bottom of the page first.",
                }
            },
            contact:{
                title:"BBE est là pour vous aider",
                text:"Vous avez des questions sur nos solutions bancaires ? Vous souhaitez en savoir plus sur notre gamme de produits ? Contactez-nous aujourd’hui",
                firstname:"Prénom",
                lastname:"Nom",
                phone:"N° de téléphone",
                phone_placeholder:"Mobile ou ligne fixe",
                email:"Mail",
                subject:"Objet",
                subject_account:"Ouverture de compte",
                subject_product:"Question à propos d'un produit",
                subject_info:"Information générale",
                subject_other:"Autre",
                message:"Votre message",
                send:"ENVOYER",
                thanks_title:"Merci d'avoir contacté BBE !",
                thanks_text:"Votre message a bien été transmis <br>Vous recevrez rapidement une confirmation par email.",
                thanks_button:"Retour à l'accueil",
                map_brussels:"Bruxelles – Siège Social",
                map_london:"Londres – Succursale",
                map_paris:"Paris – Succursale",
            },
            career:{
                job_info:'Plus d\'infos',
                apply: 'Postuler',
                apply_job: 'Postuler pour cette offre d\'emploi',
                download: 'Télécharger le document',
                city:{
                    label:'Ville',
                    brussels:'Bruxelles',
                    paris:'Paris',
                    london:'Londres',
                },
                employment:{
                    label: 'Type d\'emploi',
                    full_time:'Temps plein',
                    part_time:'Temps partiel',
                    internship:'Stage',
                    traineeship:'Traineeship',
                    student_job:'Job étudiant',
                },
                form:{
                    firstname:"Prénom",
                    lastname:"Nom de famille",
                    email:"Courriel",
                    ex_email:"ex. John{'@'}email.com",
                    phone:"Numéro de téléphone",
                    cv:"CV",
                    motivation:"Lettre de motivation (facultatif)",
                    upload_button:'Uploader',
                    remove_button:'supprimer',
                    message:"Commentaires (facultatif)",
                    max_char:"500 caractères maximum",
                    optin_privacy:'J\'ai lu et accepté la <a href="/privacy" target="_blank">déclaration de confidentialité</a> de BBE.',
                    optin_recontact:'Je donne mon consentement pour être contacté(e) par le département RH par le biais de courriels pour les futures offres d\'emploi et les opportunités pertinentes au sein de BBE. Je peux retirer ce consentement à tout moment en répondant à ces courriels reçus du département RH ou en contactant le délégué à la protection des données comme expliqué dans la <a href="/privacy" target="_blank">déclaration de confidentialité</a> of BBE (facultatif).',
                    button:'Soumettre une candidature',
                    thanks:'Votre demande a été soumise avec succès ! Vous recevrez sous peu un courriel de confirmation. Nous vous remercions de l\'intérêt que vous portez à BBE et nous nous réjouissons d\'examiner votre candidature.',
                }
            }
        }
    },
    nl: {
        message: {
            buttons: {
                contact: "Neem contact met ons op",
                read_more: "Read more about it",
                open_account : "Rekening openen",
                city: {
                    brussels: "Neem contact op met het Brusselse team",
                    paris: "Neem contact op met het team van Parijs",
                    london: "Neem contact op met het Londense team",
                }
            },
            navigation: {
                home: "Huis",
                story: "Onze waarden & verhaal",
                areas: "Werkterreinen",
                governance: "Bestuur",
                relations: "Relaties met investeerders",
                sao: "BBE Online Termijndeposito's",

                individual: "Bankieren voor particulieren",
                corporate: "Bankieren voor bedrijven",
                financial: "Financiële instellingen",
                management_solutions: "Oplossingen voor vermogensbeheer",

                contact: "Contact",
                privacy: "Privacyverklaring",
                cookie: "Cookiebeleid",
                complaint: "Een klacht indienen",
                legal_doc: "Juridische documentatie",

                career : "Carrières",
                job : "Vacatures",

                soon: "Binnenkort",
            },
            header: {
                nav_title1: "Over ons",
                nav_title2: "Geen diensten",
                nav_title3: "Contact",
            },
            footer: {
                nav_title1: "ONTDEK BBE",
                nav_title2: "RESSOURCES",
                disclaimer: "Byblos Bank Europe S.A. est autorisée et réglementée par la Banque nationale de Belgique et l'Autorité des services et marchés financiers. La succursale londonienne de Byblos Bank Europe S.A. est réputée autorisée par la Prudential Regulation Authority. Soumise à la réglementation de la Financial Conduct Authority et à la réglementation limitée de la Prudential Regulation Authority. Les détails du régime des autorisations temporaires, qui permet aux entreprises basées dans l'EEE d'opérer au Royaume-Uni pendant une période limitée tout en cherchant à obtenir une autorisation complète, sont disponibles sur le site Internet de la Financial Conduct Authority."
            },

            home_page: {
                h2: "better banking experience",
                soon: "Binnenkort",
                individual_solutions: "Bankieren voor particulieren",
                business_solutions: "Bankieren voor bedrijven",
                areas: "ONZE WERKTERREINEN",
                left_column: {
                    section_name: "FAQ",
                    title: `Questions? <br class="hide-small">Ask away.`,
                    description: "Any questions about BBE, our services or anything else? Check out our FAQ.",
                },
            },
            story_page: {
                quote_title: "Onze missie",
                history_title: "Onze Geschiedenis",
            },
            banking_page: {
                soon: "Binnenkort"
            },
            cookie: {
                header_p: `Door onze websites te bezoeken met behulp van een apparaat, gaat u ermee akkoord dat dit Cookiebeleid van toepassing is op dat gebruik, naast eventuele andere voorwaarden die van toepassing zijn.<br>
                 Dit Cookiebeleid kan periodiek worden bijgewerkt. In dat geval zullen wij u op de hoogte brengen van belangrijke wijzigingen door het plaatsen van een opvallend bericht op de website.`,
                section_name: "Laatst bijgewerkt op 02/12/2022",
                title: "Cookiebeleid",
                accordion: {
                    accordion_tab1: {
                        title:"Wat zijn koekjes?",
                        p1: "Cookies zijn kleine stukjes informatie, gewoonlijk bestaande uit slechts letters en cijfers, die online diensten verstrekken wanneer gebruikers deze bezoeken.",
                        p2: "Software op het apparaat van de gebruiker (bijvoorbeeld een webbrowser) kan cookies opslaan en deze bij een volgend bezoek terugsturen naar de website om u te herkennen.",
                        p3: "Cookies zijn niet gevaarlijk. Het zijn geen computerprogramma's en ze kunnen niet als code worden uitgevoerd. Met alle moderne versies van populaire webbrowsers kunnen gebruikers hun eigen beperkingen instellen voor het aantal cookies dat op hun apparaten wordt opgeslagen.",
                        p4: "Cookies worden opgeslagen op het apparaat van de gebruiker. Ze hebben geen toegang tot de harde schijf, dus ze kunnen geen andere informatie lezen die op de harde schijf is opgeslagen of het e-mailadres van de gebruiker verkrijgen, enz. Ze bevatten en geven aan de server slechts zoveel informatie door als de gebruikers zelf aan de website hebben verstrekt.",
                    },
                    accordion_tab2: {
                        title:"Hoe worden cookies gebruikt?",
                        p1: "Cookies zijn een specifieke technologie die informatie opslaat tussen websitebezoeken. Ze worden op tal van manieren gebruikt, zoals:",
                        li1: "onthouden wat er in een winkelmandje zit als je online winkelt;",
                        li2: "die gebruikers ondersteunt bij het inloggen op een website;",
                        li3: "het analyseren van het verkeer naar een website; of",
                        li4: "het volgen van het surfgedrag van gebruikers.",
                        p2: "Cookies kunnen nuttig zijn omdat ze een website in staat stellen het apparaat van een gebruiker te herkennen. Ze worden veel gebruikt om websites te laten werken, of efficiënter te laten werken, en om informatie te verstrekken aan de eigenaars van de site. Zonder cookies, of een andere soortgelijke methode, zouden websites geen manier hebben om iets over bezoekers te \"onthouden\", zoals hoeveel artikelen er in een winkelmandje zitten of dat ze ingelogd zijn."
                    },
                    accordion_tab3: {
                        title:"Uw rechten als bezoeker van onze website",
                        p1: "U kunt zelf bepalen hoe cookies op uw apparaat worden geplaatst vanuit uw webbrowser. Zo kunt u cookies accepteren of weigeren via een pop-upvenster wanneer u onze website voor het eerst bezoekt.",
                        p2: "U kunt uw voorkeur voor cookies wijzigen of uw toestemming volledig intrekken door te klikken op de link \"Privacyinstellingen\" bovenaan het venster.",
                        p3: "U stelt uw browser zo in dat u telkens wordt gewaarschuwd wanneer een website een cookie probeert te plaatsen. U kunt cookies beperken of blokkeren via uw browserinstellingen of cookies van specifieke websites toestaan door ze \"vertrouwde websites\" te maken in uw internetbrowser.",
                        p4: "Als u een of meer categorieën cookies hebt uitgeschakeld, kunnen wij nog steeds informatie gebruiken die via bestaande cookies is verzameld, maar wij zullen de uitgeschakelde cookies niet meer gebruiken om verdere informatie te verzamelen. U kunt bestaande cookies uit uw browser verwijderen.",
                        p5: "Houd er rekening mee dat sommige van onze diensten niet werken als uw browser of apparaat onze cookies niet accepteert.",
                    },
                    accordion_tab4: {
                        title:"Welke cookies gebruiken we?",
                        p1: "Wij gebruiken verschillende cookies voor de volgende doeleinden:",
                        li1: "Informatiebeveiliging en prestatieverbetering;",
                        li2: "Het beheren van onze website en het verbeteren van de gebruikerservaring;",
                        li3: "Een beter inzicht krijgen in de behoeften van de klant voor de voortdurende verbetering van onze website en toepassingen;",
                        li4: "Het analyseren van het gebruik van onze website en toepassingen en het maken van statistieken;",
                        li5: "Meer relevante informatie en reclame tonen op onze websites en applicatie.",
                        p2: `<strong>Essentiële en niet-essentiële cookies</strong>`,
                        p3: "Cookies kunnen worden geclassificeerd als \"essentieel\" of \"niet-essentieel\".",
                        p4: `<strong>Essentiële cookies.</strong> Dit zijn cookies die:`,
                        li6: "uitsluitend gebruikt om de transmissie van communicatie via een netwerk uit te voeren of te vergemakkelijken;",
                        li7: "strikt noodzakelijk om een online dienst (bv. onze website of een dienst op onze website) te verlenen waarom u hebt verzocht;",
                        li8: "voldoen aan wettelijke verplichtingen, bijvoorbeeld uit hoofde van de wetgeving inzake gegevensbescherming.",
                        p5: `<strong>Niet-essentiële cookies.</strong> Dit zijn alle cookies die niet onder de definitie van essentiële cookies vallen, bijvoorbeeld cookies die worden gebruikt om uw gedrag op een website te analyseren ('analytische' cookies) of cookies die worden gebruikt om u advertenties te tonen ('reclame' cookies).`,
                        p6: "Wij gebruiken cookies die onder een van de volgende categorieën vallen:",
                        th1: "Categorie van cookies",
                        th2: "Doel",
                        td1: `<p><strong>Essentieel (strikt noodzakelijk)</strong></p>`,
                        td2: `<p>Deze cookies zijn noodzakelijk voor het functioneren van de website en kunnen in onze systemen niet worden uitgeschakeld. Ze maken het mogelijk om de overdracht van communicatie via een netwerk uit te voeren of te vergemakkelijken, of om een onlinedienst (bijvoorbeeld onze website of een dienst op onze website) te verlenen waarom u hebt verzocht.</p>`,
                        td3: `<p><strong>Voorkeur en functionaliteit</strong></p>`,
                        td4: `<p>Deze cookies verzamelen informatie over uw keuzes en voorkeuren en maken het gebruik van de website praktischer, zoals het onthouden van uw voorkeurstaal of de regio waarin u zich bevindt. Ze zijn niet essentieel om te gebruiken, maar zonder deze cookies kunnen bepaalde functies niet beschikbaar zijn.</p>`,
                        td5: `<p><strong>Analytisch</strong></p>`,
                        td6: `<p>Deze cookies verzamelen informatie die wordt gebruikt om ons te helpen begrijpen hoe onze websites worden gebruikt. Wij doen dit om onze websites en applicatie voor u te verbeteren om uw ervaring te verbeteren, met behulp van een dienst van Google Analytics.</p>`,
                        td7: `<p><strong>Advertentie (targeting)</strong></p>`,
                        td8: `<p>Deze cookies worden gebruikt om reclameboodschappen relevanter te maken voor u en uw interesses. Ze voeren ook functies uit zoals voorkomen dat dezelfde advertentie voortdurend opnieuw verschijnt, ervoor zorgen dat advertenties goed worden weergegeven en in sommige gevallen advertenties selecteren die zijn gebaseerd op uw interesses.</p>`,
                    },
                    accordion_tab5:{
                        title:"Lijst van door ons gebruikte cookies",
                        th1 : "Category of cookies",
                        th2 : "Visitor Actions",
                        th3 : "Cookie",
                        th4 : "Domain",
                        th5 : "Purpose",
                        th6 : "Lifespan",

                        td1 : `<p><strong>Essential (Strictly Necessary)</strong></p>`,
                        td2 : `<p>For this type of cookies, your consent is not required.</p>`,
                        td3 : `<p>SEARCH_SAMESITE</p>`,
                        td4 : `<p>google.com</p>`,
                        td5 : `<p>Allows servers to mitigate the risk of CSRF and information leakage attacks by asserting that a particular cookie should only be sent with requests initiated from the same registrable domain.</p>`,
                        td6 : `<p>6 months</p>`,

                        td7: `<p>gdprPlugin</p>`,
                        td8: `<p>byblosbankeur.com</p>`,
                        td9: `<p>Refers to the privacy settings selected by the user.</p>`,
                        td10: `<p>1 month</p>`,

                        td11: `<p>gdprPluginGroup</p>`,
                        td12: `<p>byblosbankeur.com</p>`,
                        td13: `<p>Gets the user consent to store cookies on their device.</p>`,
                        td14: `<p>1 month</p>`,

                        td15 : `<p>group_1, group_2, group_3, group_4</p>`,
                        td16 : `<p>byblosbankeur.com</p>`,
                        td17 : `<p>Accepts cookies group.</p>`,
                        td18 : `<p>1 month</p>`,


                    },
                    accordion_tab6 : {
                        title:"Browserinstellingen wijzigen",
                        p1: "Browserinstellingen kunnen te allen tijde worden gewijzigd zodat ze geen cookies accepteren of opslaan.",
                        p2: "U kunt er ook voor kiezen om telkens een bericht te ontvangen voordat u cookies accepteert of om alleen cookies van bepaalde websites te accepteren. Meer informatie vindt u op de volgende websites:",
                        li1: `<a href="https://support.google.com/chrome/answer/95647?hl=en">Google Chrome-browser</a>`,
                        li2: `<a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">Microsoft Internet Explorer browser</a>`,
                        li3: `<a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">Mozilla Firefox-browser</a>`,
                        li4: `<a href="https://support.apple.com/en-ie/guide/safari/manage-cookies-and-website-data-sfri11471/mac">Apple Safari-browser</a>`,
                        li5: `<a href="https://www.opera.com/help/tutorials/security/privacy/">Opera webbrowser</a>`,
                    },
                    accordion_tab7 : {
                        title:"Meer informatie over cookies",
                        p1 : `Voor meer informatie over cookies en hoe u ze kunt beheren of uitschakelen, gaat u naar`,
                        p2 : `<a href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a>`,
                        p3 : `<a href="https://www.youronlinechoices.eu/">https://www.youronlinechoices.eu/</a>`,
                        p4 : `Dit zijn externe openbare links die geen verband houden met Byblos Bank Europe S.A.`,
                    },
                    accordion_tab8 : {
                        title:"\tMeer vragen over cookies?",
                        p1 : `Voor meer informatie over cookies kunt u contact opnemen met de functionaris voor gegevensbescherming van de groep op `,
                    },
                },
                content_card :{
                    p1 : `Voor de hele groep van de Europese BBE-entiteiten is er één functionaris voor gegevensbescherming met wie u ook als klant van BBE Parijs en BBE Londen contact kunt opnemen. U kunt hen contacteren met elke vraag in verband met gegevensbescherming of met uw opmerking op`,
                    p2:`Elk verzoek om uw rechten uit te oefenen of elke klacht die u indient bij BBE zal worden behandeld en beantwoord binnen de kortst mogelijke termijn. Wij zijn verplicht om u binnen 1 maand na ontvangst van uw verzoek te helpen bij de uitoefening van uw rechten of uit te leggen waarom dit niet mogelijk is. Bij een complex verzoek kan deze termijn oplopen tot 2 maanden.`
                }

            },
            sao : {
                benefits : {
                    li1 : `<strong>Easy account opening with ItsMe</strong><br><span>or via your eID card</span>`,
                    li2 : `<strong>Convenient periods for you</strong><br><span>6 months, 9 months, or 1 year</span>`,
                    li3 : `<strong>Roll over or enjoy the return</strong><br><span>Continue or stop the term at maturity</span>`,
                    li4 : `<strong>Currency of choice</strong><br><span>EUR-USD-GBP</span>`,
                    table1 : "Periode",
                    table2 : "Bruto",
                    table3 : "Net",
                },
                explain : {
                    h2 : "Het ABC van de BBE Online Termijndepositorekening",
                },
                opening : {
                    p1 : "Read the information to the bottom of the page first.",
                }
            },
            contact:{
                title:"BBE is er voor u",
                text:"Hebt u nog een vraag over onze bankoplossingen? Wilt u meer weten over onze producten? Neem vandaag nog contact met ons op.",
                firstname:"Voornaam",
                lastname:"Achternaam",
                phone:"Telefoonnummer",
                phone_placeholder:"Mobiel of vast",
                email:"E-mailadres",
                subject:"Onderwerp",
                subject_account:"Openen van een rekening",
                subject_product:"Vraag over een product",
                subject_info:"Algemene informatie\n",
                subject_other:"Ander",
                message:"Uw bericht",
                send:"Stuur",
                thanks_title:"Bedankt dat je contact hebt opgenomen met BBE!",
                thanks_text:"Je bericht is verzonden <br> U ontvangt spoedig een bevestiging per e-mail.",
                thanks_button:"Terug naar huis",
                map_brussels:"Brussel - HOOFDKANTOOR",
                map_london:"Londen - KANTOOR",
                map_paris:"Parijs – KANTOOR",
            },
            career:{
                job_info:'Meer Info',
                apply: 'Solliciteren',
                apply_job: 'Solliciteer op deze vacature',
                download: 'Download het document',
                city:{
                    label:'Stad',
                    brussels:'Brussel',
                    paris:'Parijs',
                    london:'Londen',
                },
                employment:{
                    label: 'Type Contract',
                    full_time:'Voltijds',
                    part_time:'Deeltijds',
                    internship:'Stage',
                    traineeship:'Traineeship',
                    student_job:'Studentenjob',
                },
                form:{
                    firstname:"Voornaam",
                    lastname:"Achternaam",
                    email:"E-mail",
                    ex_email:"b.v. John{'@'}email.com",
                    phone:"Telefoonnummer",
                    cv:"CV",
                    motivation:"Begeleidende brief (optioneel)",
                    upload_button:'Uploaden',
                    remove_button:'verwijderen',
                    message:"Opmerkingen (optioneel)",
                    max_char:"maximaal 500 tekens",
                    optin_privacy:'Ik heb de <a href="/privacy" target="_blank">privacyverklaring</a> van BBE gelezen en ga ermee akkoord.',
                    optin_recontact:' Ik geef toestemming om via e-mails door de HR-afdeling te worden benaderd voor toekomstige vacatures en relevante mogelijkheden binnen BBE. Ik kan deze toestemming ten allen tijde intrekken door deze e-mails van de HR-afdeling te beantwoorden of door contact op te nemen met de functionaris voor gegevensbescherming zoals uitgelegd in de <a href="/privacy" target="_blank">privacyverklaring </a> van BBE (optioneel).',
                    button:'Sollicitatie indienen',
                    thanks:'Je sollicitatie is succesvol ingediend! Je ontvangt binnenkort een bevestigingsmail. Bedankt voor je interesse in BBE en we kijken ernaar uit om je kandidaatstelling door te nemen.'
                }
            }
        }
    }
}
